import React from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    CardMedia,
    Chip,
    IconButton,
    useTheme,
    useMediaQuery
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AirIcon from '@mui/icons-material/Air';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import PsychologyIcon from '@mui/icons-material/Psychology';
import CreateIcon from '@mui/icons-material/Create';
import SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAlt';
import { useLocation, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import { useTranslation } from "react-i18next";
import dailyBreathingImg from '../../assets/daily-breathing.png';
import rejuvenateSoundsImg from '../../assets/rejuvenate-sounds.png';
import yoga from '../../assets/yoga.svg';
import manageThoughtsImg from '../../assets/manage-thoughts.png';
import gratitudeJournalImg from '../../assets/gratitude-journal.png';
import workinglate from '../../assets/workinglate.svg';
import QuickActions from './../home/QuickActions';


// Individual components
import { DailyBreathing } from './daily-breathing';
import { RejuvenateSounds } from './rejuvenate-sounds';
import { EchoSoundscapes } from './echo-soundscapes';
import { SoundMeditation } from './sound-meditation';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import YogaVideo from '../home/YogaVideo';

const Care = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const navigate = useNavigate();
    const { t } = useTranslation();
    const location = useLocation();
    const showYoga = location.state?.showYoga === true;

    // Get user package type from localStorage or context
    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    const package_type = localStorage.getItem("package_type");

    // const packageType = userData.package_type || 'premium'; // Default to premium if not set
    const sliderSettings = {
        dots: false,
        infinite: false,
        speed: 300,
        arrows: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 940,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    };

    const careItems = [
        {
            title: t("care.dailyBreathing"),
            label: t("care.labelFrequency"),
            image: manageThoughtsImg,
            icon: 'Air',
            bgGradient: 'linear-gradient(135deg, #76B7FF, #1A70FA)',
            path: "/daily-breathing"
        },
        // {
        //     title: t("care.rejuvenateSounds"),
        //     label: t("care.labelFrequency"),
        //     image: rejuvenateSoundsImg,
        //     icon: 'MusicNote',
        //     // bgGradient: 'linear-gradient(135deg, #76B7FF, #1A70FA)',
        //     bgGradient: 'linear-gradient(135deg, #D2B48C, #A67C52)',
        //     path: "/rejuvenate-sounds"
        // },
        // {
        //     title: t("care.echoSoundscapes"),
        //     label: t("care.labelFrequency"),
        //     image: yoga,
        //     icon: 'Headphones',
        //     bgGradient: 'linear-gradient(135deg, #7C7AF9, #C225E5)',
        //     path: "/echo-soundscapes"
        // },
        // {
        //     title: t("care.manageThoughts"),
        //     label: t("care.labelActivity"),
        //     image: dailyBreathingImg,
        //     icon: 'Psychology',
        //     // bgGradient: 'linear-gradient(135deg, #BABC71, #FD9616)',
        //     bgGradient: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)',
        //     path: "/sound-meditation"
        // },
        {
            title: t("care.gratitudeJournal"),
            label: t("care.labelActivity"),
            image: gratitudeJournalImg,
            icon: 'Create',
            bgGradient: 'linear-gradient(135deg, #2BADBA, #2B80B9)',
            path: '/gratitude-checkin'
        },
        {
            title: t("care.moodCheckin"),
            label: t("care.labelActivity"),
            image: workinglate,
            icon: 'SentimentSatisfiedAlt',
            bgGradient: 'linear-gradient(135deg, #BABC71, #FD9616)',
            path: '/mood-checkin'
        },
    ];

    // Filter out Gratitude Journal and Manage Thoughts for basic package
    const filteredCareItems = package_type === 'basic'
        ? careItems.filter(item =>
            item.title !== t("care.manageThoughts") &&
            item.title !== t("care.gratitudeJournal")
        )
        : careItems;

    // Split into two rows for display
    const firstRowItems = filteredCareItems.slice(0, 3);
    const secondRowItems = filteredCareItems.slice(3);

    const firstRowItemsMobile = filteredCareItems.slice(0, 2);
    const secondRowItemsMobile = filteredCareItems.slice(2, 4);
    const thirdRowItemsMobile = filteredCareItems.slice(4);

    const renderCard = (item, index) => (
        // <Box key={index} px={1} onClick={item.title === t("care.manageThoughts") ? null : () => navigate(item.path)}
        //     sx={{ cursor: item.title === t("care.manageThoughts") ? null : 'pointer' }}>
        <Box key={index} px={1} onClick={() => navigate(item.path)}
            sx={{ cursor: 'pointer' }}>

            <Card
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    borderRadius: 3,
                    boxShadow: 4,
                    width: '100%',
                    height: { xs: 250, sm: 170, md: 180 },
                    background: item.bgGradient,
                    color: '#fff',
                    overflow: 'hidden',
                }}
            >
                <Box
                    sx={{
                        flexBasis: { xs: '80%', sm: '50%' },
                        flexGrow: 1,
                        flexShrink: 1,
                        height: { xs: 150, sm: '100%' },
                        position: 'relative',
                    }}
                >
                    <CardMedia
                        component="img"
                        image={item.image}
                        alt={item.title}
                        sx={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            borderRadius: { xs: 2, sm: 0 },
                        }}
                    />
                </Box>

                <CardContent
                    sx={{
                        flexBasis: { xs: '20%', sm: '50%' }, // sets base width
                        flexGrow: 1,       // allow growing
                        flexShrink: 1,
                        // p: { xs: 2, sm: 1, md: 2 },
                        mt: { xs: 2, sm: 0 },
                        p: 0,
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center', // center content horizontally
                        textAlign: 'center',
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            // mb: 1,
                            px: 1,
                            fontSize: { xs: '0.85rem', sm: '0.85rem', md: '1rem', lg: '1.1rem' },
                            whiteSpace: 'normal',       // allow wrapping
                            wordBreak: 'break-word',    // break long words if needed
                            display: 'block',           // standard block element
                            textAlign: 'center',
                        }}
                    >
                        {item.title}
                    </Typography>

                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1 }}>
                        <Chip
                            label={item.label}
                            size="small"
                            icon={
                                item.icon === 'Air' ? <AirIcon sx={{ fontSize: 16, color: '#fff !important' }} /> :
                                    item.icon === 'MusicNote' ? <MusicNoteIcon sx={{ fontSize: 16, color: '#fff !important' }} /> :
                                        item.icon === 'Headphones' ? <HeadphonesIcon sx={{ fontSize: 16, color: '#fff !important' }} /> :
                                            item.icon === 'Psychology' ? <PsychologyIcon sx={{ fontSize: 16, color: '#fff !important' }} /> :
                                                item.icon === 'Create' ? <CreateIcon sx={{ fontSize: 16, color: '#fff !important' }} /> :
                                                    item.icon === 'SentimentSatisfiedAlt' ? <SentimentSatisfiedAltIcon sx={{ fontSize: 16, color: '#fff !important' }} /> :
                                                        <Box component="img" src={item.icon} alt="icon" sx={{ width: 16, height: 16 }} />
                            }
                            sx={{
                                height: 24,
                                backgroundColor: 'rgba(255,255,255,0.2)',
                                color: '#fff',
                                px: 1,
                                fontSize: { xs: '0.7rem', sm: '0.6rem', md: '0.7rem', lg: '0.8rem' },
                                width: 'fit-content',
                                maxWidth: '100%',
                                whiteSpace: 'nowrap',
                                '.MuiChip-icon': { ml: 0, mr: 0, width: 16, height: 16 },
                            }}
                        />
                    </Box>

                </CardContent>
            </Card>

        </Box>
    );

    return (

        <Box sx={{
            background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
            minHeight: {
                xs: 'calc(100vh - 56px)',
                sm: 'calc(100vh - 64px)',
                md: 'calc(100vh - 70px)',
            },
        }}>
            <Box sx={{
                p: { xs: 2, sm: 2 }, width: '100%'
            }}>
                {/* Header */}
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: { xs: 2, md: 3 }, justifyContent: "space-between" }}>
                    <Typography variant="h6" sx={{
                        fontWeight: 700, background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}>
                        {t("care.title")}
                    </Typography>
                    <IconButton
                        onClick={() => navigate(-1)}
                        sx={{
                            backgroundColor: '#F0F5FF',
                            width: { xs: 28, sm: 30, md: 40 },
                            height: { xs: 28, sm: 30, md: 40 },
                            borderRadius: '50%',
                            color: '#0B2D6B',
                            '&:hover': {
                                backgroundColor: '#E0EBFF'
                            }
                        }}
                    >
                        <ArrowBackIcon sx={{ fontSize: { xs: '20px', sm: '22px' } }} />
                    </IconButton>
                </Box>

                {/* Cards Section - centered with maxWidth */}
                <Box sx={{ maxWidth: 1200, mx: 'auto' }}>
                {/* First Row Slider */}
                {isMobile ? (
                    <>
                        <Box sx={{ mb: 2, px: 1, display: "flex", gap: 2, flexDirection: "column" }}>
                            {/* {showYoga && ( */}
                            <YogaVideo />
                            {/* )} */}
                            <QuickActions />
                        </Box>


                        {/* Mobile view: 2 cards per row, 3 rows */}
                        <Slider {...sliderSettings}>
                            {firstRowItemsMobile.map(renderCard)}
                        </Slider>

                        <Box height={20} />

                        <Slider {...sliderSettings}>
                            {secondRowItemsMobile.map(renderCard)}
                        </Slider>

                        <Box height={20} />

                        <Slider {...sliderSettings}>
                            {thirdRowItemsMobile.map(renderCard)}
                        </Slider>
                    </>
                ) : (
                    <>
                        <Box sx={{ mb: 2, px: 1, display: "flex", gap: 2 }}>
                            {/* {showYoga && ( */}
                            <YogaVideo />
                            {/* )} */}
                            <QuickActions />
                        </Box>


                        {/* Tablet/Desktop view: 3 cards per row, 2 rows */}
                        <Slider {...sliderSettings}>
                            {firstRowItems.map(renderCard)}
                        </Slider>

                        <Box height={20} />

                        <Slider {...sliderSettings}>
                            {secondRowItems.map(renderCard)}
                        </Slider>
                    </>
                )}
                </Box>

            </Box>
        </Box>
    );
};

// Export all components
export {
    DailyBreathing,
    RejuvenateSounds,
    EchoSoundscapes,
    SoundMeditation
};

export default Care;


